import { Wysiwyg } from '@mui/icons-material';
import { Dialog, DialogContent, Grid, IconButton, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { IClientUploadDemographicAPI } from '../../models/APITransationLog/IAPITransationLog';
import { Transition } from '../GlobalStyles/DialogBoxTransition';
import { DialogTitleHeader } from '../GlobalStyles/DialogStyle';
import { useRowStyles } from './APITransactionLogCss';
import TooltipSmall from '../GlobalStyles/TooltipSmall';

const ViewMoreDemographicAPI: React.FC<{ row: IClientUploadDemographicAPI }> = (props) => {
    const { row } = props;
    const classes = useRowStyles();
    const [open, setOpen] = useState(false);
    const formatDate = (date: Date) => new Date(date).toLocaleDateString();

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <React.Fragment>
            <TooltipSmall title="View More">
                <IconButton size='small' onClick={handleOpen}>
                    <Wysiwyg fontSize='small' color='primary'/>
                </IconButton>
            </TooltipSmall>

            <Dialog TransitionComponent={Transition}
                PaperProps={{ style: { borderRadius: 10 } }}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                fullWidth={true}
                maxWidth={'sm'}
            >
                <DialogTitleHeader id="responsive-dialog-title" onClose={handleClose}>
                    <Typography variant="h6" className={classes.titleHeader}>
                        Demograhic Details
                    </Typography>
                </DialogTitleHeader>

                <DialogContent >
                    <Grid container spacing={2} mt={1}>
                        {Object.entries(row).map(([Key, value]) => (
                            <Grid item xs={6} key={Key}>
                                <TextField variant='outlined' size='small' disabled
                                    label={Key}
                                    value={
                                        value instanceof Date
                                            ? formatDate(value)
                                            : typeof value === 'boolean'
                                                ? value ? 'Yes' : 'No'
                                                : value
                                    }
                                    InputProps={{ readOnly: true }} fullWidth />
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default ViewMoreDemographicAPI